import { Grid, Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { Fragment } from "react";
import LoadingComp from "../LoadingComp";
import TableItemComp from "./TableItemComp";
import PaginationComp from "../PaginationComp";

export default function TableComp({
  sortData,
  bodyList,
  isLoading,
  headers,
  action,
  improvingComp,
  total,
  pagi,
  setPagi,
  activeRow,
  dynamicHeight,
  dynamicWidth,
  height,
  noBackground,
  TableFooterComponent,
  extraTableRow,
}) {
  return (
    <Fragment>
      {!improvingComp ? (
        <>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              borderRadius: "12px",
              height: height ?? "100%",
              maxHeight: dynamicHeight ?? "100%",
              background: "var(--white)",
              border: "1px solid var(--grey)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ overflowX: "auto" }}>
              <Table
                sx={{ minWidth: dynamicWidth ?? 1200 }}
                aria-label="simple table"
              >
                <TableHead
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    background: "var(--white)",
                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                  }}
                >
                  <TableRow>
                    {headers?.map((v) => {
                      return (
                        [undefined, true]?.includes(v?.display) && (
                          <TableCell
                            width={v?.width}
                            key={v?.id}
                            sx={{ p: "14px 16px" }}
                          >
                            {v?.comp && v?.comp}
                            {!v?.comp && (
                              <Typography
                                variant="body1"
                                fontWeight="bold"
                                align={v?.align}
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {v?.title}
                              </Typography>
                            )}
                          </TableCell>
                        )
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading && (
                    <TableRow sx={{ background: "var(--white)" }}>
                      <TableCell colSpan={10}>
                        <LoadingComp />
                      </TableCell>
                    </TableRow>
                  )}
                  {!isLoading && Array.isArray(bodyList) && !!bodyList?.length ? (
                    bodyList?.map((v) => {
                      return (
                        <TableItemComp
                          activeRow={noBackground ? false : activeRow === v?._id}
                          key={v?._id}
                          item={v}
                          sortData={sortData}
                          action={action}
                        />
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={20}
                        align="center"
                      >
                        Không có dữ liệu
                      </TableCell>
                    </TableRow>
                  )}
                  {extraTableRow}
                </TableBody>
              </Table>
            </Box>
            {TableFooterComponent && (
              <Box
                sx={{
                  borderTop: "1px solid var(--grey)",
                  px: 2,
                  py: 1.5,
                }}
              >
                {TableFooterComponent}
              </Box>
            )}
          </TableContainer>

          {!isLoading ? (
            <PaginationComp
              total={total}
              pagi={pagi}
              setPagi={setPagi}
            />
          ) : (
            <Box
              display="flex"
              justifyContent="flex-end"
            >
              <Skeleton
                width="120px"
                height="44px"
              />
            </Box>
          )}
        </>
      ) : (
        <Grid
          container
          sx={{
            border: "1px solid var(--light-grey)",
            borderRadius: "12px",
            // height: "80vh",
            overflow: "auto",
          }}
        >
          {improvingComp}
        </Grid>
      )}
    </Fragment>
  );
}
